import type { ReactNode } from 'react';
import U2000RequireRole from '../u2000Core/components/controls/U2000RequireRole';
import U3303, { U3303ROLES } from './U3303';
import U3303HolidayYearList from './components/list/U3303HolidayYearList';
import U3303HolidayYearForm from './components/form/U3303HolidayYearForm';

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3303Routes: RouteObject[] = [
  {
    path: 'U3303',
    element: <U2000RequireRole allowedRoles={[U3303ROLES.READ]} />,
    children: [
      {
        path: '',
        element: <U3303 />,
        children: [
          { index: true, element: <U3303HolidayYearList /> },
          { path: ':id', element: <U3303HolidayYearForm /> },
        ],
      },
    ],
  },
];

export default U3303Routes;
